<template>
  <v-app>
    <v-container fluid>
      <v-row >
        <!-- Left Panel: Others Info -->
        <v-col md="3" cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Others Info
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="pa-2">
                    <v-col cols="12">
                      <v-autocomplete
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="po_id.value.value"
                        :items="poList"
                        :item-title="item => item.code || `PO-${item.id}`"
                        :item-value="item => item.id"
                        :error-messages="po_id.errorMessage.value"
                        @update:model-value="onPoChange"
                        autocomplete="off"
                        clearable
                      >
                        <template #label>
                          PO <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>

                      <v-date-input
                        label="Cutting Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="cutting_date.value.value"
                        :error-messages="cutting_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>

                      <input
                        v-model="cutting_id.value.value"
                        type="hidden"
                      />
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <!-- Right Panel: Cutting Details -->
        <v-col md="9" cols="12">
          <v-expansion-panels v-model="panel2">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Cutting Details
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">

                  <!-- Details Table -->
                  <v-row class="pt-0">
                    <v-col cols="12">
                      <v-table
                        density="compact"
                        :loading="loading"
                        fixed-header
                        class="table-dotted-border-bottom mt-2"
                      >
                        <thead>
                          <!-- <tr>
                            <th class="text-center mb-2" style="width: 5%">SL</th>
                            <th class="text-left mb-2" style="width: 30%">Color</th>
                            <th class="text-left mb-2" style="width: 30%">Size</th>
                            <th class="text-center mb-2" style="width: 20%">Quantity</th>
                            <th class="text-center mb-2" style="width: 15%">Action</th>
                          </tr> -->
                        </thead>
                        <tbody>
                          <tr
                            v-for="(detail, index) in detailRows"
                            v-if="detailRows.length > 0"
                            :key="index"
                          >
                            <td class="text-center py-1">{{ index + 1 }}</td>
                            <td class="py-1">
                              <v-text-field
                                v-model="detail.style"
                                label="Style *"
                                type="text"
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                style="width: 100%;"
                                hide-details
                                readonly
                                disabled
                              ></v-text-field>
                            </td>
                            <td class="py-1">
                              <v-select
                                v-model="detail.color_id"
                                :items="colorList"
                                :item-title="item => item.name"
                                :item-value="item => item.id"
                                label="Color *"
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                hide-details
                                readonly="true"
                                disabled="true"
                                :error="!!detailErrors[index]?.color_id"
                                :error-messages="detailErrors[index]?.color_id"
                              ></v-select>
                            </td>
                            <td class="py-1">
                              <v-select
                                v-model="detail.size_id"
                                :items="sizeList"
                                label="Size *"
                                :item-title="item => item.name"
                                :item-value="item => item.id"
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                hide-details
                                readonly="true"
                                disabled="true"
                                :error="!!detailErrors[index]?.size_id"
                                :error-messages="detailErrors[index]?.size_id"
                              ></v-select>
                            </td>
                            <td class="text-center py-1">
                              <v-text-field
                                v-model.number="detail.qty"
                                label="Quantity *"
                                type="number"
                                variant="outlined"
                                density="compact"
                                bg-color="grey-lighten-4"
                                style="width: 100%;"
                                hide-details
                                :min="1"
                                :error="!!detailErrors[index]?.qty"
                                :error-messages="detailErrors[index]?.qty"
                              ></v-text-field>
                            </td>
                            <td class="text-left py-1">

                              <v-btn v-if=" (index != detailRows.length - 1) || (detailRows.length > 1)" icon variant="tonal" size="small" color="primary" class="pa-1" @click="removeDetailRow(index)">
                                <v-icon color="red">mdi-close</v-icon>
                              </v-btn>

                              <v-btn class="d-none" v-if="index == detailRows.length - 1" variant="tonal" icon size="small" color="primary" @click="addDetailRow">
                                <v-icon color="blue">mdi-plus</v-icon>
                              </v-btn>
                            </td>
                          </tr>

                          <tr v-else-if="loading == true">
                            <td colspan="5" class="text-center">
                              <v-skeleton-loader
                                type="heading"
                                :loading="loading"
                              />
                            </td>
                          </tr>

                          <tr v-else>
                            <td colspan="5" class="text-center text-red">
                              You have no cutting details
                            </td>
                          </tr>
                        </tbody>
                      </v-table>
                    </v-col>
                  </v-row>
                  <!-- Close Details Table -->

                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-row class="pt-2">
                      <v-col cols="8"></v-col>
                      <v-col cols="4">
                        <v-layout class="justify-end">
                          <v-btn
                            class="bg-grey-darken-1 me-2"
                            variant="flat"
                            :loading="loading"
                            @click="submitForm(0)"
                          >
                            Draft
                          </v-btn>
                          <v-btn
                            class="bg-primary"
                            variant="flat"
                            @click="submitForm(1)"
                            :loading="loading"
                          >
                            {{ isEntryMode ? "Save" : "Update" }}
                          </v-btn>
                        </v-layout>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { ref, watch } from "vue";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { toast } from "vue3-toastify";

export default {
  name: "CuttingCreate",
  
  data() {
    return {
      panel: [0],
      panel2: [0],
    };
  },

  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const loading = ref(false);
    const isEntryMode = ref(true);
    const detailRows = ref([{ style: "", color_id: "", size_id: "", qty: 0 }]);
    const detailErrors = ref({});

    const { handleSubmit, resetForm, setFieldValue } = useForm({
      validationSchema: yup.object({
        po_id: yup.number().required().label("PO"),
        cutting_date: yup.date().required().label("Cutting Date"),
      }),
    });

    const po_id = useField("po_id");
    const cutting_date = useField("cutting_date");
    const cutting_id = useField("cutting_id");

    const addDetailRow = () => {
      detailRows.value.push({style : "", color_id: "", size_id: "", qty: 0 });
    };

    const removeDetailRow = (index) => {
      if (detailRows.value.length > 1) {
        detailRows.value.splice(index, 1);
        delete detailErrors.value[index];
        const newErrors = {};
        Object.keys(detailErrors.value).forEach((key) => {
          const idx = parseInt(key);
          if (idx > index) newErrors[idx - 1] = detailErrors.value[key];
          else if (idx < index) newErrors[idx] = detailErrors.value[key];
        });
        detailErrors.value = newErrors;
      }
    };

    const validateDetails = () => {
      detailErrors.value = {};
      let isValid = true;

      // Filter valid rows (must have all required fields including IDs)
      const validRows = detailRows.value.filter(row => 
        row.color_id && 
        row.size_id && 
        row.qty > 0 && 
        row.production_order_item_id && 
        row.production_order_breakdown_id
      );

      if (validRows.length === 0) {
        toast.error("Please select a PO to load breakdowns, or ensure at least one valid detail row exists");
        return false;
      }

      detailRows.value.forEach((detail, index) => {
        const errors = {};
        if (!detail.color_id) { errors.color_id = "Color is required"; isValid = false; }
        if (!detail.size_id) { errors.size_id = "Size is required"; isValid = false; }
        if (!detail.qty || detail.qty <= 0) { errors.qty = "Quantity must be greater than 0"; isValid = false; }
        if (Object.keys(errors).length) detailErrors.value[index] = errors;
      });

      return isValid;
    };

    const onPoChange = async (poId) => {
      if (!poId) {
        // Only clear if we're in entry mode (creating new)
        if (isEntryMode.value) {
          detailRows.value = [{style : "",  color_id: "", size_id: "", qty: 0 }];
        }
        return;
      }

      // Only load breakdowns if we're in entry mode (creating new) or if details are empty
      const hasExistingDetails = detailRows.value.length > 1 || 
        (detailRows.value.length === 1 && (detailRows.value[0].color_id || detailRows.value[0].size_id || detailRows.value[0].qty > 0));
      
      if (!isEntryMode.value && hasExistingDetails) {
        // Don't overwrite existing details when editing
        return;
      }

      loading.value = true;
      try {
        // Fetch full production order details with items and breakdowns
        const response = await store.dispatch("getProductionOrderById", { id: poId });
        const poData = response.data.data;

        // Extract breakdowns from all items
        const breakdowns = [];
        if (poData.items && poData.items.length > 0) {
          poData.items.forEach((item) => {
            if (item.breakdowns && item.breakdowns.length > 0) {
              item.breakdowns.forEach((breakdown) => {
                // Only include breakdowns where order_quantity > cut_qty (cuttable)
                if (breakdown.order_quantity > breakdown.cut_qty) {
                  breakdowns.push({
                    style: item.style?.code,
                    color_id: breakdown.color_id,
                    size_id: breakdown.size_id,
                    qty: breakdown.order_quantity - breakdown.cut_qty, // Available quantity for cutting
                    production_order_item_id: item.id,
                    production_order_breakdown_id: breakdown.id,
                  });
                }
              });
            }
          });
        }

        // Populate detailRows with breakdown data
        if (breakdowns.length > 0) {
          detailRows.value = breakdowns;
        } else {
          detailRows.value = [{style: "",  color_id: "", size_id: "", qty: 0 }];
          toast.info("No cuttable items found for this production order");
        }
      } catch (error) {
        console.error("Error loading production order details:", error);
        toast.error("Failed to load production order details");
        detailRows.value = [{style: "",  color_id: "", size_id: "", qty: 0 }];
      } finally {
        loading.value = false;
      }
    };

    const goBack = () => {
      router.push("/bhp/cutting-records");
    };

    const submitForm = (status) => {
      setFieldValue('status', status);
      submit();                       
    };

    const submit = handleSubmit((values) => {
      if (!validateDetails()) {
        toast.error("Please fill all detail fields correctly");
        return;
      }

      const payload = {
        production_order_id: values.po_id,
        cutting_date: values.cutting_date,
        status: values.status,
        details: detailRows.value
          .filter((row) => row.color_id && row.size_id && row.qty > 0) // Filter out empty rows
          .map((row) => ({
            production_order_item_id: row.production_order_item_id,
            production_order_breakdown_id: row.production_order_breakdown_id,
            color_id: row.color_id,
            size_id: row.size_id,
            qty: Number(row.qty),
          })),
      };

      loading.value = true;
      const id = values.cutting_id;

      const action = id ? "updateProductionCutting" : "saveProductionCutting";
      const param = id ? { id, data: payload } : payload;

      store.dispatch(action, param)
        .then(() => {
          toast.success(id ? "Updated Successfully!" : "Created Successfully!");
          // Refresh the list before navigating
          store.dispatch("getProductionCuttingList");
          goBack();
        })
        .catch((err) => {
          toast.error(err.response?.data?.message || "Something went wrong");
        })
        .finally(() => { loading.value = false; });
    });

    const loadCuttingData = (id) => {
      loading.value = true;
      detailErrors.value = {};

      store.dispatch("getProductionCuttingById", id)
        .then((response) => {
          const data = response.data.data;
          isEntryMode.value = false;

          po_id.value.value = data.production_order_id;
          cutting_date.value.value = data.cutting_date;
          cutting_id.value.value = data.id;

          detailRows.value = data.details?.length
            ? data.details.map(d => ({ 
                color_id: d.color_id, 
                size_id: d.size_id, 
                qty: Number(d.qty),
                production_order_item_id: d.production_order_item_id,
                production_order_breakdown_id: d.production_order_breakdown_id,
              }))
            : [{ color_id: "", size_id: "", qty: 0 }];
        })
        .catch(() => {
          toast.error("Failed to load data");
          goBack();
        })
        .finally(() => { loading.value = false; });
    };

    watch(() => route.params.id, (id) => {
      if (id) loadCuttingData(id);
      else {
        isEntryMode.value = true;
        resetForm();
        detailRows.value = [{ color_id: "", size_id: "", qty: 0 }];
      }
    }, { immediate: true });

    return {
      po_id,
      cutting_date,
      cutting_id,
      detailRows,
      detailErrors,
      loading,
      isEntryMode,
      addDetailRow,
      removeDetailRow,
      onPoChange,
      goBack,
      submit,
      submitForm,
      resetForm,
    };
  },

  computed: {
    poList() { return this.$store.getters.getCuttingableProductionOrderList || []; },
    colorList() { return this.$store.getters.getProductionColorList || []; },
    sizeList() { return this.$store.getters.getProductionSizeList || []; },
  },

  created() {
    //if (!this.$store.getters.getCuttingableProductionOrderList.length) {
      this.$store.dispatch("getCuttingableProductionOrderList");
    //}
    if (!this.$store.getters.getProductionColorList.length) this.$store.dispatch("getProductionColorList");
    if (!this.$store.getters.getProductionSizeList.length) this.$store.dispatch("getProductionSizeList");
  },
};
</script>
